import { Mutator } from 'final-form';

import { BanUserFields } from './validator';

export const cleanDate: Mutator<BanUserFields> = (_, state, utils) => {
  utils.changeValue(state, 'date', () => '');
};
